import { defineMessages } from "react-intl";

const PREFIX = "HTTP";
export default defineMessages({
  responseErrorCodeMsg: {
    id: `${PREFIX}.response.error.codes`,
    defaultMessage: "Sorry, something went wrong. Please try later",
  },
  responseErrorBulkExportMaxLimitMsg: {
    id: `${PREFIX}.response.error.codes.bulkexport.maxlimit`,
    defaultMessage: "There is more than 1 million lines in your selection. Please, select CSV export or reduce the selection",
  },
});
